module.exports = __webpack_public_path__ + "media/15.dead5033.mp3";